"use strict";

var _slicedToArray = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./utils");

function fromSplit(split) {
  var _split = _slicedToArray(split, 5),
      protectedHeader = _split[0],
      encrypted_key = _split[1],
      iv = _split[2],
      ciphertext = _split[3],
      tag = _split[4];

  var jwe = {
    ciphertext: ciphertext,
    iv: iv,
    protected: protectedHeader,
    tag: tag
  };
  if (encrypted_key) jwe.recipients = [{
    encrypted_key: encrypted_key
  }];
  return jwe;
}

function encodeRecipient(recipient) {
  var encRec = {};
  if (recipient.encrypted_key) encRec.encrypted_key = utils_1.fromBase64url(recipient.encrypted_key);
  if (recipient.header) encRec.header = recipient.header;
  return encRec;
}

function encode(jwe) {
  var encJwe = {
    ciphertext: utils_1.fromBase64url(jwe.ciphertext),
    protected: utils_1.fromBase64url(jwe.protected),
    iv: utils_1.fromBase64url(jwe.iv),
    tag: utils_1.fromBase64url(jwe.tag)
  };
  if (jwe.aad) encJwe.aad = utils_1.fromBase64url(jwe.aad);
  if (jwe.recipients) encJwe.recipients = jwe.recipients.map(encodeRecipient);
  if (jwe.unprotected) encJwe.unprotected = jwe.unprotected;
  return encJwe;
}

function decodeRecipient(encoded) {
  var recipient = {};
  if (encoded.encrypted_key) recipient.encrypted_key = utils_1.toBase64url(encoded.encrypted_key);
  if (encoded.header) recipient.header = encoded.header;
  return recipient;
}

function decode(encoded) {
  var jwe = {
    ciphertext: utils_1.toBase64url(encoded.ciphertext),
    protected: utils_1.toBase64url(encoded.protected),
    iv: utils_1.toBase64url(encoded.iv),
    tag: utils_1.toBase64url(encoded.tag)
  };
  if (encoded.aad) jwe.aad = utils_1.toBase64url(encoded.aad);
  if (encoded.recipients) jwe.recipients = encoded.recipients.map(decodeRecipient);
  if (encoded.unprotected) jwe.unprotected = encoded.unprotected;
  return jwe;
}

exports.default = {
  fromSplit: fromSplit,
  decode: decode,
  encode: encode
};